// pageRoutes.js — the pages that have been renamed, and what they used to be called.
//
// A page's URL is its identity in two places that outlive the code: a bookmark somebody saved,
// and the `allowed_pages` string stored against every user in permissions_melbournecity. Renaming a
// route therefore does two things nobody asked for — it 404s the bookmark, and it silently
// revokes access, because userCanAccess compares the stored path to the new one and they no
// longer match.
//
// So a rename records its old name here and nothing is rewritten in the warehouse. Access is
// compared on the CANONICAL id, so a grant stored under either spelling is understood, and
// main.js turns each old path into a redirect so an old link still arrives.
//
// This map only ever grows. An entry is not removed once "everyone has re-saved their
// permissions", because there is no way to know that, and the cost of keeping it is one line.

/** Old page id -> the id it has now. */
export const PAGE_ID_ALIASES = {};

/** The id a page is known by today, given any id it has ever had. */
export function canonicalPageId(id) {
  return PAGE_ID_ALIASES[id] || id;
}

/** [oldPath, newPath] for every rename, for the redirect routes. */
export const PAGE_REDIRECTS = Object.entries(PAGE_ID_ALIASES);
